import template from './employee-details.html';
import controller from './employee-details.controller';

let employeeDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default employeeDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-details/employee-details.component.js